import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { _className, Button, ComponentSync, Label, LL_H_C, ModuleFE_MouseInteractivity, mouseInteractivity_PopUp, openContent } from '@nu-art/thunderstorm-frontend/index';
import './Renderer_DataField.scss';
import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { variableType_AttributeInstance } from '@app/hcs-shared';
import { ModuleFE_Advisor_Variable, ModuleFE_RuntimeFinding } from '@app/advisor-frontend';
import { FindingType_Textual } from '@app/advisor-shared';
import { iconTooltipId } from '../../_style/icon-tooltip/index.js';
export class Renderer_DataField_Base extends ComponentSync {
    fieldRef = React.createRef();
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.variable ??= ModuleFE_Advisor_Variable.cache.unique(nextProps.variableId);
        if (!state.variable)
            throw new MUSTNeverHappenException(`Could not get variable for id ${nextProps.variableId}`);
        state.disabled = !!nextProps.disabled;
        state.isChiefComplaint = !!nextProps.isChiefComplaint;
        state.containerSelector = nextProps.containerSelector ?? '.ts-tree';
        state.suggestedValueFindingId = nextProps.suggestedValueFindingId;
        return state;
    }
    //######################### Logic #########################
    getClassName() {
        return _className('data-field-v2', this.state.disabled && 'disabled');
    }
    getVarName = () => {
        if (this.state.variable.type !== variableType_AttributeInstance)
            return this.state.variable.name;
        const split = this.state.variable.name.split('.');
        return split[1];
    };
    getContextMenu = () => {
        if (this.state.disabled)
            return {};
        const actions = [];
        const isComplaint = ModuleFE_Advisor_Variable.isComplaint(this.state.variable);
        if (isComplaint && this.props.toggleChiefComplaint) {
            const isChiefComplaint = this.state.isChiefComplaint;
            const label = isChiefComplaint ? 'Mark as an associated symptom' : 'Mark as chief complaint';
            actions.push({
                label: label,
                action: () => this.props.toggleChiefComplaint(),
            });
        }
        if (!actions.length)
            return {};
        return openContent.popUpV2.bottom({
            id: 'finding-context-menu',
            offset: 0,
            event: 'onContextMenu',
            content: () => {
                return actions.map((action, index) => _jsx(Button, { variant: 'text', onClick: async () => {
                        await action.action();
                        ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                    }, children: action.label }, index));
            },
        });
    };
    onVarNameClick = (e) => {
    };
    getSuggestedValueTooltipLogic = () => {
        const finding = ModuleFE_RuntimeFinding.cache.unique(this.state.suggestedValueFindingId);
        if (!finding || finding.type !== FindingType_Textual)
            return {};
        return openContent.tooltip.top(iconTooltipId, finding.value, { offset: 8, });
    };
    //######################### Render #########################
    render_VarName = () => {
        const varName = this.getVarName();
        return _jsx(Label, { className: 'data-field__var-name', tooltip: varName, containerSelector: this.state.containerSelector, onClick: this.onVarNameClick, ...this.getContextMenu(), children: varName });
    };
    render() {
        return _jsxs(LL_H_C, { className: this.getClassName(), innerRef: this.fieldRef, children: [this.render_VarName(), this.render_DataIntake()] });
    }
}
//# sourceMappingURL=Renderer_DataField_Base.js.map